import { http, prepareHttpQuery } from 'http';

export default {
  getMasterData: () => http.get('/masterdata'),

  getCheckinOutMasterData: () => http.get('/flex/checkinout/masterdata'),

  getTiresMasterData: filters => {
    const baseUrl = '/flex/tires/masterdata';
    const queries = prepareHttpQuery(filters);
    return http.get(`${baseUrl}${queries}`);
  },

  cms: (partnerId, patternId) => {
    const locale = process.env.APP_LOCALE;
    const appId = process.env.APP_ID;
    return http.get(`/cms/${locale}/templates/edocs-contents/patterns/${patternId}`, {
      headers: {
        AppId: appId,
        PartnerId: partnerId
      }
    });
  },

  login: identityData => {
    const baseUrl = `/flex/checkinout/list`;
    const identityQueries = prepareHttpQuery(identityData);
    return http.get(`${baseUrl}${identityQueries}`);
  },

  getTransferActs: filters => {
    const baseUrl = `/flex/checkinoutTransfer/list`;
    const identityQueries = prepareHttpQuery(filters);
    return http.get(`${baseUrl}${identityQueries}`);
  },

  catalogByPartnerIdAndStep: (partnerId, stepId) =>
    http.get(`/catalog/front/${partnerId}/${stepId}`),

  getMunicipalities: idProvince => http.get(`/flex/municipalities/masterdata/${idProvince}`),

  getRequiredDocumentationOffline: partnerId =>
    http.get(`/catalog/front/${partnerId}/checkinout-offline-docs`),

  getRequiredImagesOffline: partnerId =>
    http.get(`/catalog/front/${partnerId}/checkinout-offline-images`)
};
